// Pixii Motors brand overrides, deep-merged on top of the Mender base themes via createTheme(base, overrides).
// Lunar-gray/silver palette taken from the Shadow scooter color chart.
import { DARK_MODE, LIGHT_MODE } from '@northern.tech/store/constants';

export const pixiiColors = {
  graphite: '#1b1d21',
  lunarGray: '#4a4f57',
  silver: '#b8bcc2',
  mist: '#eef0f2',
  steel: '#6b717a'
};

const light = {
  palette: {
    primary: { main: pixiiColors.lunarGray, dark: '#33373d' },
    secondary: { lighter: '#8c929b', light: '#7a8089', main: pixiiColors.steel },
    grey: { 300: '#eef0f2', 200: '#e9ebed', 100: '#e4e6e9', 50: '#dfe2e5' },
    background: { light: '#fbfbfc', lightgrey: '#f4f5f6', darkBlue: pixiiColors.graphite },
    text: { primary: 'rgba(27, 29, 33, 0.87)', entryLink: pixiiColors.lunarGray }
  }
};

const dark = {
  palette: {
    primary: { main: pixiiColors.silver, dark: '#d4d7db' },
    secondary: { lighter: '#a9aeb5', light: '#9aa0a8', main: '#8c929b' },
    grey: { A400: '#2a2d32', 900: pixiiColors.silver, 800: '#c6c9ce', 700: '#d4d7db' },
    background: { default: '#1e2024', light: '#24272b', lightgrey: '#2a2d32', paper: '#2a2d32' }
  }
};

export const pixiiOverrides = { [LIGHT_MODE]: light, [DARK_MODE]: dark };
